import toastr from 'toastr';

export const toastrNotify = option => {
  toastr.options = {
    "closeButton":       option.closeButton || false,
    "debug":             option.debug || false,
    "newestOnTop":       option.newestOnTop || false,
    "progressBar":       option.progressBar || true,
    "positionClass":     option.positionClass || "toast-top-right",
    "preventDuplicates": option.preventDuplicates || false,
    "onclick":           option.onclick || null,
    "showDuration":      option.showDuration || "300",
    "hideDuration":      option.hideDuration || "1000",
    "timeOut":           option.timeOut || "5000",
    "extendedTimeOut":   option.extendedTimeOut || "1000",
    "showEasing":        option.showEasing || "swing",
    "hideEasing":        option.hideEasing || "linear",
    "showMethod":        option.showMethod || "fadeIn",
    "hideMethod":        option.hideMethod || "fadeOut"
  }

  if ( option.typeMessage === 'success' ) {
    return toastr.success(option.message, option.title);
  } else if ( option.typeMessage === 'info' ) {
    return toastr.info(option.message,option.title);
  } else if ( option.typeMessage === 'warning' ) {
    return toastr.warning(option.message, option.title);
  } else if ( option.typeMessage === 'error' ) {
    return toastr.error(option.message,option.title);
  }

}
